import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GLOBALPROPS } from './GlobalApp.jsx';

import { withRouter } from 'react-router';
import Loadable from 'react-loadable';
import Loading from './M1/Lib/Loading.jsx'

import { withStyles } from '@material-ui/core';
import withWidth from '@material-ui/core/withWidth';

const Logged = Loadable({
	loader: () => import('./Logged.jsx'),
	loading(props) {
		return (<Loading message="Loading content" {...props}/>);
	},
});

const NotLogged = Loadable({
	loader: () => import('./NotLogged.jsx'),
	loading(props) {
		return (<Loading message="Loading login"  {...props}/>);
	}
});


export const styles = () => ({
});

class Lynvictus extends Component {

	constructor(props) {
		super(props);
		this.setNewSubMenu = this.setNewSubMenu.bind(this);

		this.state = {
			"docPath": "",
			logged: false
		};


		this.registeredMenuFunc = undefined;


		// --------- Modify state from route (directly call from rootForReact) ------
		if (props.route && props.route.params) {
			this.state = Object.assign(this.state, props.route.params);
		}
		if (typeof props.params !== 'undefined') {
			this.state = Object.assign(this.state, props.params);
		}
		// --------- Modify state from route (directly call from rootForReact) ------
	}

	setNewSubMenu(menu) {
		if (this.registeredMenuFunc) return this.registeredMenuFunc(menu);
		//console.log("Don't know how to ad menu ", menu);
	}

	componentWillReceiveProps(props) {
		if (props.global.logged != this.state.logged) {
			this.setState({ logged: props.global.logged });
		}
	}

	render() {
		if (this.state.logged) {
			return <Logged key="logged" global={this.props.global} />
		}
		return <NotLogged key="notlogged" global={this.props.global} />
	}
}
Lynvictus.propTypes = {
	logged : PropTypes.bool,
	classes : PropTypes.object,
	route : PropTypes.object,
	params : PropTypes.object,
	global : GLOBALPROPS,
  };

export default withRouter(withWidth()(withStyles(styles,{withTheme:true})(Lynvictus)));
